import Calculator from '../components/Calculator';

export default function HomePage() {
  return <Calculator />;
}
